class CartProgressBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.calculateProgress();
  }

  calculateProgress() {
    const cartTotal = parseFloat(this.querySelector('.cart-progress-bar').dataset.cartTotal);
    const priceOptions = this.querySelectorAll('.progress-bar-price');
    const firstOption = parseFloat(this.querySelector('.cart-progress-bar').dataset.progressFirst);  
    const secondOption = parseFloat(this.querySelector('.cart-progress-bar').dataset.progressSecond);  
    const thirdOption = parseFloat(this.querySelector('.cart-progress-bar').dataset.progressThird);  
    const fourthOption = parseFloat(this.querySelector('.cart-progress-bar').dataset.progressFourth);  
    const progressLine = this.querySelector('.progress-bar-line');
    const circle = this.querySelector('.progress-bar-line-circle');

    console.log([...priceOptions].find(priceOption => priceOption.dataset.count === '1'));

    priceOptions.forEach(priceOption => priceOption.classList.remove('active'));
    if (cartTotal >= fourthOption) {
      progressLine.style.width = `100%`;
      circle.style.transform = `translate(0, -50%)`;
      [...priceOptions].find(priceOption => priceOption.dataset.count === '4').classList.add('active');
    } else if (cartTotal >= thirdOption) {
      progressLine.style.width = `62.5%`;
      [...priceOptions].find(priceOption => priceOption.dataset.count === '3').classList.add('active');
    } else if (cartTotal >= secondOption) {
      progressLine.style.width = `37.5%`;
      [...priceOptions].find(priceOption => priceOption.dataset.count === '2').classList.add('active');
    } else if (cartTotal >= firstOption) {
      progressLine.style.width = `12.5%`;
      [...priceOptions].find(priceOption => priceOption.dataset.count === '1').classList.add('active');
    } else {
      progressLine.style.width = `0`;
      circle.style.display = 'none';
    }
  }
}

customElements.define('cart-progress-bar', CartProgressBar);